export { default } from './TransferFundsForm';



// WEBPACK FOOTER //
// ./src/components/UserFlowFunds/TransferFundsForm/index.js